"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));
var _edit = _interopRequireDefault(require("./edit"));
var _attachmentUi = _interopRequireDefault(require("./attachmentUi"));
var _plugin = _interopRequireDefault(require("@ckeditor/ckeditor5-core/src/plugin"));
var _widget = _interopRequireDefault(require("@ckeditor/ckeditor5-widget/src/widget"));
// 插件类，创建插件必须基于这个类扩展
// 实例化一个类，然后导出
var UploadPdf = exports.default = /*#__PURE__*/function (_Plugin) {
  function UploadPdf() {
    (0, _classCallCheck2.default)(this, UploadPdf);
    return (0, _callSuper2.default)(this, UploadPdf, arguments);
  }
  (0, _inherits2.default)(UploadPdf, _Plugin);
  return (0, _createClass2.default)(UploadPdf, null, [{
    key: "requires",
    get: function get() {
      return [_edit.default, _attachmentUi.default, _widget.default];
    }
  }]);
}(_plugin.default);